import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Consent to share? ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Tick this box to share: ")
const _hoisted_4 = { class: "flex flex-col gap-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" I Agree ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Decline ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gv_type = _resolveComponent("gv-type")!
  const _component_scopes = _resolveComponent("scopes")!
  const _component_gv_checkbox = _resolveComponent("gv-checkbox")!
  const _component_gv_label = _resolveComponent("gv-label")!
  const _component_gv_notice = _resolveComponent("gv-notice")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_gv_button = _resolveComponent("gv-button")!
  const _component_mobile = _resolveComponent("mobile")!

  return (_ctx.authorise)
    ? (_openBlock(), _createBlock(_component_mobile, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_gv_type, { variant: "display-md" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_gv_type, { class: "pt-4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.authorise.serviceName) + " would like to access the following information: ", 1)
              ]),
              _: 1
            }),
            (_ctx.authorise.hasScopes && _ctx.showRequiredScopes)
              ? (_openBlock(), _createBlock(_component_scopes, {
                  key: 0,
                  class: "mt-4",
                  scopes: _ctx.authorise.serviceProps.scopes,
                  scopeDescriptions: _ctx.authorise.serviceProps.scopeDescriptions,
                  consentMarkdownContent: 
              _ctx.authorise.serviceProps.consentMarkdownContent
            
                }, null, 8, ["scopes", "scopeDescriptions", "consentMarkdownContent"]))
              : _createCommentVNode("", true),
            (_ctx.authorise.hasOptionalScopes)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.authorise.serviceProps.optionalScopes, (optionalScope) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mt-4",
                    key: optionalScope
                  }, [
                    _createVNode(_component_gv_label, { side: "right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_gv_checkbox, {
                          name: "optionalScopes",
                          scheme: "secondary",
                          value: optionalScope,
                          modelValue: _ctx.optionalScopes,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.optionalScopes) = $event))
                        }, null, 8, ["value", "modelValue"])
                      ]),
                      label: _withCtx(() => [
                        _createVNode(_component_gv_type, { class: "ml-2" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_scopes, {
                      class: "mt-4",
                      scopes: [optionalScope],
                      scopeDescriptions: _ctx.authorise.serviceProps.scopeDescriptions,
                      consentMarkdownContent: 
                _ctx.authorise.serviceProps.consentMarkdownContent
              
                    }, null, 8, ["scopes", "scopeDescriptions", "consentMarkdownContent"])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]),
        footer: _withCtx(() => [
          (_ctx.acceptProcess.error)
            ? (_openBlock(), _createBlock(_component_gv_notice, {
                key: 0,
                class: "mb-6",
                scheme: "error",
                text: _ctx.acceptProcess.error
              }, null, 8, ["text"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_gv_button, {
              size: "lg",
              text: "I Agree",
              onClick: _ctx.onAccept
            }, {
              default: _withCtx(() => [
                _createVNode(_component_gv_type, { class: "w-full text-center" }, {
                  default: _withCtx(() => [
                    (_ctx.acceptProcess.loading)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: ['fad', 'spinner-third'],
                          spin: ""
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_5
                        ], 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_gv_button, { variant: "text" }, {
              default: _withCtx(() => [
                _createVNode(_component_gv_type, {
                  scheme: "custom",
                  class: "text-outbackRed text-center w-full",
                  onClick: _ctx.onDecline
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_mobile, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_gv_notice, { scheme: "error" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.authoriseProcess.error), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}